import get from '~/utils/get'
import { Breakpoints } from '~/enums'

export function isDesktop(): boolean {
  const width = get(window, 'screen.width', Breakpoints.XL)
  return width > Breakpoints.MD
}
